import React from 'react';
import { useDeviceDetection } from '../../hooks/useDeviceDetection';
import ReporteDetalleView from './ReporteDetalleView';
import ReporteDetalleMovilView from './ReporteDetalleMovilView';

/**
 * Vista auto que detecta el dispositivo y redirige a la versión apropiada
 */
const ReporteDetalleAutoView: React.FC = () => {
  const { isMobile, isTablet } = useDeviceDetection();
  const esMobileOTablet = isMobile || isTablet;

  if (esMobileOTablet) {
    return <ReporteDetalleMovilView />;
  }

  return <ReporteDetalleView />;
};

export default ReporteDetalleAutoView;
